import { render, staticRenderFns } from "./playChapter.vue?vue&type=template&id=3a18ea76&scoped=true"
import script from "./playChapter.vue?vue&type=script&lang=js"
export * from "./playChapter.vue?vue&type=script&lang=js"
import style0 from "./playChapter.vue?vue&type=style&index=0&id=3a18ea76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18ea76",
  null
  
)

export default component.exports